import { reactive, Div, H3, Button, Label, Input, Span, Form, } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import LoadingDots from '../generic/LoadingCircle';

const loadingState = () => {
	const submitButton = document.querySelector('#submit-naming')
	submitButton.disabled = true;
	submitButton.innerHTML = '';
	submitButton.appendChild(new LoadingDots)
}

const undoLoading = () => {
	const submitButton = document.querySelector('#submit-naming')
	submitButton.disabled = false;
	submitButton.childNodes.forEach((node) => { return node.remove() })
	submitButton.innerHTML = 'Save'
}
export class GroupNamingDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Create New Group',
			},
			id: 'naming-dialog',
			foot: {},
		}
	}
	ready(properties) {
		const groupWith = properties.groupWith
		const interventionDialog = properties.type == 'intervention'
		let newCollection: any
		let groupName = reactive('')
		this.body.append(
			Form('#naming-form', [
				Label('.group-label', [
					groupWith ? H3(`Name of new ${interventionDialog ? 'intervention' : 'outcome'} group for: ${properties.groupWith}`) : Span(`${interventionDialog ? 'Intervention' : 'Outcome'} Name`),
					Input(groupName, {
						id: 'name-input',
						maxLength: 120,
						type: 'text',
						placeholder: 'Name..',
						autofocus: true
					}),
				]),
			], {
				onsubmit(event) {
					event.preventDefault()
					save()
				}
			})
		)
		this.footer.leftControls.append(
			Button('.btn.secondary', {
				textContent: 'Cancel',
				type: 'submit',
				onclick: () => {
					this.hide()
				},
			}),
		)
		const save = async () => {
			// Check for empty input before anything else
			if (groupName.valueOf()) {
				loadingState()
				try {
					properties.onName(groupName.valueOf())
					this.hide()
				} catch (error) {
					undoLoading()
					console.error("Error occured when trying to add a new group: ", error)
				}
			} else {
				alert('Name for the new group cannot be empty, please enter a name below')
			}
		}
		this.footer.rightControls.append(
			Button('.btn.primary#submit-naming', {
				textContent: 'Save',
				onclick: save,
			}),
		)
	}
	show(event) {
		super.show(event)
	}
	onShown() {
		this.querySelector('#name-input').focus()
	}
}
